<template>
  <v-card-text class="mt-6" :loading="loading">
    <v-row v-if="!loading">
      <v-col md="12">
        <v-row>
          <v-col cols="12" md="6" sm="12" v-if="audiences.length">
            <v-card outlined class="pa-4">
              <h3>Audiência</h3>

              <v-list two-line>
                <v-list-item class="mb-0" v-for="(audience, index) in audiences" :key="index">
                  <v-list-item-content>
                    <v-list-item-title><strong>{{
                      $n(audience.audience)
                        }}</strong> {{ audience.label }}</v-list-item-title>
                    <!-- <p>{{ audience.label }}</p> -->
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-card outlined class="pa-4">
              <h3>Interesses</h3>
              <v-chip color="primary" class="ma-1" small v-for="(chip, index) in interests" :key="index">{{ chip
                }}</v-chip>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="12">
            <v-card outlined class="pa-4">
              <h3>Sexo</h3>

              <PieChart :chartData="genderData" :options="pieOptions" />






              <!-- <label class="--label" v-if="item.asus.gender"
                >Fonte: {{ item.asus.gender }}</label
              > -->
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-card outlined class="mb-6 pa-4">
              <h3>Faixa etária</h3>
              <PieChart :chartData="ageGroupData" :options="pieOptions" />

              <!-- <label class="--label" v-if="item.asus.charts.sources.ageGroup"
                >Fonte: {{ item.asus.charts.sources.ageGroup }}</label
              > -->
            </v-card>
          </v-col>
          <v-col cols="12" md="4" sm="12">
            <v-card outlined class="pa-4">
              <h3>Classe social</h3>
              <PieChart :chartData="socialClassData" :options="pieOptions" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
// import * as am4core from "@amcharts/amcharts4/core";
// import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// am4core.useTheme(am4themes_animated);


import PieChart from './PieChart.vue'


export default {
  name: "InfoTab",
  components: { PieChart },

  data() {
    return {
      colors: ['#fc846e', '#ffb7a7', '#e85b42', '#6edffc', '#6efca5', '#a56efc'],
      item: [],
      loading: true,

      pieOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontColor: '#444',
            padding: 20,
            fontSize: 13
          }
        },
        plugins: {
          legend: {
            position: 'top',
            labels: { color: '#444' }
          }
        }
      }
    };
  },
  props: {
    snap: Object,
  },
  computed: {
    genderData() {
      const { gender } = this.item.asus
      const labels = []
      const datasets = [
        {
          backgroundColor: [],
          borderColor: '#fff',
          borderWidth: 2,
          data: []
        }
      ]
      gender.forEach((item) => {
        labels.push(item.type)
        if (item.type == 'Masculino')
          datasets[0].backgroundColor.push('#6eacff')
        else
          datasets[0].backgroundColor.push('#c5aafe') 

        datasets[0].data.push(item.percentage)

      }) 
      return { 
        labels: labels, 
        datasets: datasets
      }
    },

    socialClassData() {
      const { social_class } = this.item.asus
      const labels = []
      const datasets = [
        {
          backgroundColor: [],
          borderColor: '#fff',
          borderWidth: 2,
          data: []
        }
      ]
      social_class.forEach((item, index) => {
        labels.push(item.type)
        datasets[0].backgroundColor.push(this.colors[index])
        datasets[0].data.push(item.percentage)

      })
      return {
        labels: labels,
        datasets: datasets
      }
    },

    ageGroupData() {
      const { age_group } = this.item.asus
      const labels = []
      const datasets = [
        {
          backgroundColor: [],
          borderColor: '#fff',
          borderWidth: 2,
          data: []
        }
      ]
      age_group.forEach((item, index) => {
        if (item.range.max == 120)
          labels.push(`${item.range.min}anos +`)
        else
          labels.push(`${item.range.min} à ${item.range.max} anos`)

        datasets[0].backgroundColor.push(this.colors[index])


        datasets[0].data.push(item.percentage)

      })
      return {
        labels: labels,
        datasets: datasets
      }
    },


    interests() {
      let result = [];
      if (this.loading) return ''
      this.item.asus.interests.forEach((interest) => {
        let text = "";
        if (interest.industry) {
          text = interest.industry;
          if (interest.category) text = `${text} - ${interest.category}`;
          if (interest.gender) text = `${text} - ${interest.gender}`;
        } else {
          text = interest;
        }
        result.push(text);
      });
      return result;
    },
    ageGroup() {
      if (this.loading) return ''
      let result = [];
      this.item.asus.charts.ageGroup.forEach((ageGroup) => {
        let key = ["99", "ou mais"].includes(ageGroup.range.max)
          ? `${ageGroup.range.min}+`
          : `${ageGroup.range.min} à ${ageGroup.range.max}`;
        result.push({ agegroup: key, percentage: ageGroup.percentage });
      });
      return result;
    },
    audiences() {
      if (this.loading) return ''
      let result = [];
      this.item.asus.audience.forEach((audience) => {
        if (audience.multiple)
          switch (audience.multiple.toLowerCase()) {
            case "d":
            case "dia":
            case "day":
              result.push({
                label: `${audience.label} por dia`,
                audience: audience.value,
              });
              break;
            case "i":
            case "min":
            case "minuto":
              result.push({
                label: `${audience.label} por minuto`,
                audience: audience.value,
              });
              break;
            case "h":
            case "hora":
            case "hour":
              result.push({
                label: `${audience.label} por hora`,
                audience: audience.value,
              });
              break;
            case "w":
            case "week":
            case "semana":
              result.push({
                label: `${audience.label} por semana`,
                audience: audience.value,
              });
              break;
            case "m":
            case "month":
            case "mês":
              result.push({
                label: `${audience.label} por mês`,
                audience: audience.value,
              });
              break;
            case "y":
            case "year":
            case "ano":
              result.push({
                label: `${audience.label} por ano`,
                audience: audience.value,
              });
              break;
            default:
              result.push({
                label: `${audience.label}`,
                audience: audience.value,
              });
              break;
          }
      });
      return result;
    },
  },
  mounted() {
    this.item = JSON.parse(JSON.stringify(this.snap))
    setTimeout(() => {
      this.loading = false
      // this.buildGenderChart();
      // this.buildAgeGroupChart();
      // this.buildSocialClassChart();
    }, 1000)

  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    buildGenderChart() {
      let genderChart = am4core.create(
        this.$refs.chatGenderId,
        am4charts.PieChart
      );
      genderChart.colors.list = [];

      //   genderChart.hiddenState.properties.opacity = 0; // this creates initial fade-in
      //   genderChart.responsive.enabled = true;
      // genderChart.legend = new am4charts.Legend();
      this.item.asus.charts.gender.forEach((gender) => {
        if (gender.type == "Masculino") gender.color = "#6eacff";
        if (gender.type == "Feminino") gender.color = "#c5aafe";
      });
      genderChart.data = this.item.asus.charts.gender;

      // Add and configure Series
      var pieSeries = genderChart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "percentage";
      pieSeries.dataFields.category = "type";

      pieSeries.ticks.template.disabled = true;
      pieSeries.alignLabels = false;
      pieSeries.labels.template.text = "{value.percent.formatNumber('#')}%";
      pieSeries.labels.template.radius = am4core.percent(-40);
      pieSeries.labels.template.fill = am4core.color("white");

      pieSeries.tooltip.getFillFromObject = false;
      pieSeries.tooltip.label.propertyFields.fill = "#ffffff";
      pieSeries.tooltip.background.propertyFields.stroke = "#4c4c4c";
      pieSeries.tooltip.label.fill = am4core.color("#4c4c4c");
      pieSeries.tooltip.label.fontSize = 16;
      pieSeries.slices.template.propertyFields.fill = "color";

      pieSeries.slices.template.tooltipText = "{type}: [bold]{percentage}%[/]";

      pieSeries.labels.template.adapter.add(
        "radius",
        function (radius, target) {
          if (target.dataItem && target.dataItem.values.value.percent < 10) {
            return 0;
          }
          return radius;
        }
      );

      pieSeries.labels.template.adapter.add("fill", function (color, target) {
        if (target.dataItem && target.dataItem.values.value.percent < 10) {
          return am4core.color("#4c4c4c");
        }
        return color;
      });

      genderChart.legend = new am4charts.Legend();
      genderChart.legend.position = "top";
      genderChart.legend.labels.template.text = "{type}"
      genderChart.legend.valueLabels.template.disabled = true;
      var markerTemplate = genderChart.legend.markers.template;
      markerTemplate.width = 10;
      markerTemplate.height = 10;
    },

    buildAgeGroupChart() {
      var ageGroupChart = am4core.create(
        this.$refs.ageGroupId,
        am4charts.XYChart
      );
      ageGroupChart.colors.list = [am4core.color("#fb6e51")];
      ageGroupChart.data = this.ageGroup.reverse();

      var categoryAxis = ageGroupChart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "agegroup";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.strokeWidth = 0;
      var valueAxis = ageGroupChart.xAxes.push(new am4charts.ValueAxis());

      valueAxis.renderer.grid.template.strokeWidth = 0;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.renderer.ticks.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      ageGroupChart.xAxes.push(new am4charts.ValueAxis());
      var series = ageGroupChart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = "percentage";
      series.dataFields.categoryY = "agegroup";

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusBottomRight = 4;
      series.columns.template.column.cornerRadiusTopRight = 4;
      series.columns.template.column.fillOpacity = 0.8;



      //   var valueLabel = series.columns.template.createChild(am4core.Label);
      //   valueLabel.text = "{percentage}%";
      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{percentage}%";
      valueLabel.label.fontSize = 14;
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 5;
      valueLabel.label.truncate = false;
      valueLabel.label.hideOversized = false;

      series.tooltip.getFillFromObject = false;
      series.tooltip.label.propertyFields.fill = "#ffffff";
      series.tooltip.background.propertyFields.stroke = "#4c4c4c";
      series.tooltip.label.fill = am4core.color("#4c4c4c");
      series.tooltip.label.fontSize = 16;
      series.columns.template.tooltipText = "{categoryY} anos: [bold]{valueX}%[/]";
    },

    buildSocialClassChart() {
      var socialClassChart = am4core.create(
        this.$refs.socialClassId,
        am4charts.XYChart
      );
      socialClassChart.colors.list = [am4core.color("#fb6e51")];
      socialClassChart.data = this.item.asus.charts.socialClass.reverse();

      var categoryAxis = socialClassChart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "type";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.strokeWidth = 0;
      var valueAxis = socialClassChart.xAxes.push(new am4charts.ValueAxis());

      valueAxis.renderer.grid.template.strokeWidth = 0;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.renderer.ticks.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;

      socialClassChart.xAxes.push(new am4charts.ValueAxis());
      var series = socialClassChart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = "percentage";
      series.dataFields.categoryY = "type";

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.cornerRadiusBottomRight = 4;
      series.columns.template.column.cornerRadiusTopRight = 4;
      series.columns.template.column.fillOpacity = 0.8;



      //   var valueLabel = series.columns.template.createChild(am4core.Label);
      //   valueLabel.text = "{percentage}%";
      var valueLabel = series.bullets.push(new am4charts.LabelBullet());
      valueLabel.label.text = "{percentage}%";
      valueLabel.label.fontSize = 14;
      valueLabel.label.horizontalCenter = "left";
      valueLabel.label.dx = 5;
      valueLabel.label.truncate = false;
      valueLabel.label.hideOversized = false;

      series.tooltip.getFillFromObject = false;
      series.tooltip.label.propertyFields.fill = "#ffffff";
      series.tooltip.background.propertyFields.stroke = "#4c4c4c";
      series.tooltip.label.fill = am4core.color("#4c4c4c");
      series.tooltip.label.fontSize = 16;
      series.columns.template.tooltipText = "Classe social {categoryY}: [bold]{valueX}%[/]";
    },
  },
};
</script>
<style lang="scss">
.--info {
  .card {
    position: relative;
  }

  .v-list {
    padding: 0;
  }

  .v-list-item {
    padding: 0;
  }

  .v-list-item__content {
    padding: 0;
  }

  h3 {
    color: #707070;
  }

  .--label {
    position: absolute;
    bottom: 10px;
    left: 10px;
    padding: 3px;
    background: #fff;
    color: #909090;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>